import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type {
  ReturnedClientsFilterViewsListParams,
  ReturnedClientsFilterViewsListResponseData,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const RETURNED_CLIENTS_FILTER_VIEWS_LIST_QUERY_KEY =
  'returned_clients_filter_views_list';

export const useReturnedClientsFilterViewsListQuery = (
  params: ReturnedClientsFilterViewsListParams,
) =>
  useQuery({
    queryKey: [
      RETURNED_CLIENTS_FILTER_VIEWS_LIST_QUERY_KEY,
      params.url,
      params.queryParams,
    ],
    queryFn: () =>
      HttpClient.request<ReturnedClientsFilterViewsListResponseData>({
        method: 'GET',
        url: params.url,
        params: params.queryParams,
      }),
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
